import { create } from 'zustand';

interface ILoggedOnBehalfStore {
  loggedOnBehalf: boolean;
  setLoggedOnBehalf: (status: boolean) => void;
}

export const useLoggedOnBehalfStore = create<ILoggedOnBehalfStore>((set) => ({
  loggedOnBehalf: false,

  setLoggedOnBehalf: (status) => set(() => ({ loggedOnBehalf: status })),
}));
